import React, {Component} from "react";
import PropTypes from "prop-types";
import userResolver from "./UserResolver";
import {Selector} from "../../components";
import {UserSelector} from "./UserSelector";

export class UserIdSelector extends Component {
  static propTypes = {
    selected: PropTypes.any,
    ...UserSelector.propTypes
  }

  render() {
    const {selected, ...props} = this.props

    return <UserSelector
      {...props}

      selectByKey
      resolveSelection={userIds => userResolver.fetchPromise(userIds)}
      selected={selected}
      onSelected={(...args) => this.props.onSelected(...args)}
    />
  }
}